import {
  IStockRowProps,
  StockRow,
} from 'components/commandpanel/RequiredStock/RequiredStock';
import React, { useMemo } from 'react';

export interface IAdditiveProps {
  additives: IStockRowProps[];
  dropNumber: number;
}
export interface Props {
  compProps: IAdditiveProps;
}
const AdditivesInfo = (props: Props) => {
  const { compProps } = props;
  const { additives, dropNumber } = compProps;
  const additivesList = useMemo(() => {
    return additives.map((additiveProps, index) => {
      return <StockRow key={index} {...additiveProps} />;
    });
  }, [additives]);
  return (
    <div id="additivesinfo-wrapper" className="flex flex-col">
      <div
        id="additivesinfo-drop"
        className="flex flex-row w-full justify-start pl-[10px]"
      >
        <label id="additives-drop-title" className="w-[30%]">
          Drop
        </label>
        <label id="additives-drop-number-text" className="w-[30%]">
          {dropNumber}
        </label>
      </div>
      {additivesList}
    </div>
  );
};

export default AdditivesInfo;
